const validateRequiredFieldsManually = (postPutData, isRegistering, requiredFieldsArr) => {
          let obj = {};
        

          requiredFieldsArr.forEach(field => { 
               if(!postPutData[field]) {
                    obj[field] = true
               }
                        // Additional fields if user is registering
               if (isRegistering) {
                    if (!postPutData.user_eula) {
                         obj.user_eula = true;
                    }
                    if (!postPutData.user_password) {
                         obj.user_password = true;
                    }
             }
          })
 
 
        
          return obj;

}

export {validateRequiredFieldsManually}